import axios from "axios";
import ROUTES from "../utils/constants/endpoints";

const API = axios.create({
    baseURL: "https://services.solucore.com/solutrak/api", // Base API URL
    headers: { "Content-Type": "application/json" },
});

// Function to remove all cookies on logout using standard browser APIs
export const clearSession = () => {
    const cookieNames = [
        "isLoggedIn", "token", "userType", "defaultLat", "defaultLng",
        "firstName", "lastName", "phoneNumber", "mobileNumber",
        "profilePictureUrl", "company"
    ];

    cookieNames.forEach(name => {
        // Set the cookie's expiration date to the past to delete it
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });

    // Redirect to login using the window.location object
    window.location.href = ROUTES.LOGIN;
};

// Add token to every request
API.interceptors.request.use(
    (config) => {
        const cookies = document.cookie
            .split("; ")
            .reduce((acc, cookie) => {
                const [key, value] = cookie.split("=");
                acc[key] = value;
                return acc;
            }, {});

        const token = cookies.token; // Read from cookies

        if (token) {
            config.headers["Valid-token"] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Handle 401 responses globally without using React hooks
API.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error) => {
        // Check for 401 Unauthorized response
        if (error.response && error.response.status === 401) {
            // Call the session clearing function which now uses standard browser APIs
            clearSession();
        }
        // Reject the promise for other errors or to allow further handling
        return Promise.reject(error);
    }
);

export default API;
